export default "__VITE_ASSET__DLe59ECp__"